<template>
  <div class="pack_container">
        <div class="card_header"  :style="headerStyle">
            <span>{{"Pack"}}</span>
            <span>{{packName}}</span>
        </div>
        <div class="card_main"  :style="mainStyle">
            <div :style="`color:${colors.mainText}`">
                 <span class="pack_price"><span class="pack_currency">{{currency}}</span >{{price}}</span> /{{period}}
            </div>
            <ul>
                <li v-for="(item,index) in offersList" :key="index" class="offer_item"><span class="check_mark" :style="{borderColor:checkColor}"></span> {{item}}</li>
            </ul>
            <div class="btn_container">
                 <Button v-bind="button" @click="$emit('handleclick')"></Button>
            </div>
        </div>
  </div>
</template>

<script >
    import Button from '../global/Button.vue'
    export default {
        components : { Button },
        props: {
            packName : { type : String, default : 'BASIC'},
            price : {type: Number, default: 0},
            currency : {type : String, default: "$"},
            period : {type : String, default: "Month"},
            offersList : { type : Array, default:  () => (['10 uploads / months', 'private uploads'])},
            colors : {type : Object, default : () => ({header : 'primary', main : null, headertext : "#fff", mainText:"black"})},
            button : {type : Object, default: () => ({name : 'Choose Plan', backgroundColor : 'red', padding: {x:3, y:1}, margin : 0}) },
            checkColor : { type : String, default : '#12b112'}
        },
        computed: {
            headerStyle(){
                return {
                    "background-color" : this.colors.header,
                    color : this.colors.headerText
                }
            },
            mainStyle(){
                return {
                    "background-color" : this.colors.main,
                    color : this.colors.mainText
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
$primary: #ff4f56;
$secondary: #4309b0;
$tertiary: #32007d;
$tertiary-light: #6d49a2;

    .pack_container {
        border : 1px solid rgb(209, 209, 209);
        border-radius : 2rem;
        width : 19rem;
        // min-height: 30rem;
        height : 100%;
        background-color : rgb(243, 240, 240);
    }
    .card_header {
        border-radius : 2rem 2rem 0 0 ;
        padding : .5rem 1rem;
        display : flex;
        flex-direction : column;
        align-items : center;
        justify-content : center;
        margin-bottom : .5rem;
        background-color : $secondary;
        color : white;


        span:first-child {
            font-size : 1.5rem;
            font-weight: 400;
        }
        span:last-child {
            font-size : 2.2rem;
            font-weight: 600;
            text-transform: uppercase;
        }
    }

    .card_main {
        padding : 1rem;
        display : flex;
        flex-direction : column;
        background-color : white;
        position: relative;
        min-height: 22.9rem;
        border-radius : 0 0 2rem 2rem ;
        height: 100%;

        div {
            align-self: center;
            padding : 1rem 0;
            font-size : 1.7rem;
            font-weight: 100;
          
        }
        ul {
            padding : 2rem 1rem;
        }
         li {
             list-style: none;
             font-weight: 500;
             font-size: .9rem;
             position: relative;
             padding : .5rem 0 ;
             display  : flex;
             align-items : center;

            &::after {
                content : '';
                display : 'block';
                border : 1px solid transparent;
                background-color : transparent; 
                position : absolute;
                left: 0;
                right: 0;
                bottom : 0
            }
         }
    }
    .pack_price {
        font-weight: 600;
        font-size : 2.5rem;
    }
    .pack_currency {
        font-weight: 300;
    }
    .btn_container {
        position : absolute;
        bottom : -2rem;
        left : 0;
        right: 0;
        display: flex;
        align-items : center;
        justify-content : center;
    }
    .check_mark {
        border-bottom: .2rem solid;
        border-right : .2rem solid;
        padding : .2rem;
        margin-right: .8rem;
        height : 1rem;
        transform : rotate(37deg);
        // border-color : #12b112;
    }
    .primary { 
        background-color : $primary !important;
        color : white !important;
        div, span{
            color : white !important;
        }
        .check_mark {
            border-color : white;
            border-bottom: .1rem solid;
            border-right : .1rem solid;
        }
    }
    .secondary { 
        @extend .primary;
        background-color : $secondary !important;
        color : white !important;
    }
    .tertiary { 
        @extend .primary;
        background-color : $tertiary !important;
        color : white !important;
    }
    .tertiary-light { 
        @extend .primary;
        background-color : $tertiary-light !important;
        color : white !important;

    }
</style>


// WEBPACK FOOTER //
// src/components/global/PlanCard.vue